
import CommonUtils from '@/common-utils';
import { LoginVO } from '@/views/biz/login/vo/login.vo';
import axios from 'axios';
import 'swiper/css/swiper.css';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FindResult extends Vue {

  member: Array<LoginVO> = [] as Array<LoginVO>;

  get getSignOnId(): LoginVO | {memId: ''} {
    const memId = this.member.filter(item => {
      if(item.joinType == '11') {
        return item
      }
    })

    return memId.length > 0 ? memId[0]: {memId: ''}
  }

  get getSnsId() {
    return this.member.filter(item => {
      // SNS계정만
      if(item.joinType == '11') {
        return
      }
        
      // 애플로 로그인했으면서 애플이면
      if(this.isSignOnApple == true && item.joinType == '14') {
        return
      }

      return item
    })
  }
  //애플로그인 체크
  get isSignOnApple() {
    return !this.getSignOnId.memId
  }

  beforeCreate() {
    if (window.opener) {
      window.opener.location.href = CommonUtils.createStaticUrl(this, 'FindIdResult');
      window.close();
      return;
    }
    
    axios.get('/login/member-id')
    .then(r=> {
      if(r.data) {
        this.member = r.data;
      } 
    }).catch(()=>{
      this.$router.push({name: 'Login'})
    })
  }
}
